export default __webpack_public_path__ + "static/stairs-81aae3bd6c97821988cac74085d80c98.svg";